import { useMutation, useQuery } from "@tanstack/react-query";
import apiServices from "../ApiServices/request-handler";
import { showSwalAlert } from "../components/showSwalAlert";

export const LoginUser = (setLoadingToapi, location, login, navigate) => {
  return useMutation({
    mutationFn: async (loginUser) => {
      const response = await apiServices.login(loginUser);
      return response.data;
    },
    onSuccess: (data) => {
      login(
        data?.data?.accessToken,
        data?.data?.user.role,
        data?.data?.user._id
      );
      const redirectTo =
        new URLSearchParams(location.search).get("redirect") || "/";
      navigate(redirectTo);
      setLoadingToapi(false);
      showSwalAlert("Success!", data?.message, "success");
    },
    onError: (error) => {
      const message = error.response
        ? error.response.data.message
        : error.message;
      setLoadingToapi(false);
      showSwalAlert("Oops...", message, "error");
    },
  });
};

export const RegisterUser = (setLoadingToapi, navigate) => {
  return useMutation({
    mutationFn: async (regsiterUser) => {
      const response = await apiServices.regsiter(regsiterUser);
      return response.data;
    },
    onSuccess: (data) => {
      setLoadingToapi(false);
      navigate("/login");
      showSwalAlert("Success!", data?.message, "success");
    },
    onError: (error) => {
      const message = error.response
        ? error.response.data.message
        : error.message;
      setLoadingToapi(false);
      showSwalAlert("Oops...", message, "error");
    },
  });
};

export const BillingAddress = (setLoadingToapi, navigate) => {
  return useMutation({
    mutationFn: async (billingAddress) => {
      const response = await apiServices.billingAddress(billingAddress);
      return response.data;
    },
    onSuccess: (data) => {
      navigate("/verificationCode");
      setLoadingToapi(false);
      showSwalAlert("Success!", data?.message, "success");
    },
    onError: (error) => {
      const message = error.response
        ? error.response.data.message
        : error.message;
      setLoadingToapi(false);
      showSwalAlert("Oops...", message, "error");
    },
  });
};
export const UseforgetPassword = (
  setLoadingToapi,
  navigate,
  isNavigate = true
) => {
  return useMutation({
    mutationFn: async (forgetPassword) => {
      const response = await apiServices.forgetPassword(forgetPassword);
      return response.data;
    },
    onSuccess: (data) => {
      if (isNavigate) {
        navigate("/OtpVerification");
      }
      setLoadingToapi(false);
      showSwalAlert("Success!", data?.message, "success");
    },
    onError: (error) => {
      const message = error.response
        ? error.response.data.message
        : error.message;
      setLoadingToapi(false);
      showSwalAlert("Oops...", message, "error");
    },
  });
};
export const useOtpVerify = (setLoadingToapi, navigate) => {
  return useMutation({
    mutationFn: async (otpVerify) => {
      const response = await apiServices.otpVerify(otpVerify);
      return response?.data;
    },
    onSuccess: (data) => {
      navigate("/resetPassword");
      setLoadingToapi(false);
      localStorage.setItem("resetToken", data?.data?.resetToken);
      showSwalAlert("Success!", data?.message, "success");
    },
    onError: (error) => {
      const message = error.response
        ? error.response.data.message
        : error.message;
      setLoadingToapi(false);
      showSwalAlert("Oops...", message, "error");
    },
  });
};
export const useResetPassword = (setLoadingToapi, navigate) => {
  return useMutation({
    mutationFn: async (resetPassword) => {
      const response = await apiServices.resetPassword(resetPassword);
      return response.data;
    },
    onSuccess: (data) => {
      navigate("/login");
      setLoadingToapi(false);
      localStorage.clear("resetToken");
      showSwalAlert("Success!", data?.message, "success");
    },
    onError: (error) => {
      const message = error.response
        ? error.response.data.message
        : error.message;
      setLoadingToapi(false);
      showSwalAlert("Oops...", message, "error");
    },
  });
};

export const useUpdateUserProfileMutation = (setLoadingToapi, queryClient) => {
  return useMutation({
    mutationFn: async (updateUserProfile) => {
      const response = await apiServices.updateUserProfile(updateUserProfile);
      return response.data;
    },
    onSuccess: (data) => {
      setLoadingToapi(false);
      queryClient.invalidateQueries("userProfile");
      showSwalAlert("Profile", data?.message, "success");
    },
    onError: (error) => {
      const message = error.response
        ? error.response.data.message
        : error.message;
      setLoadingToapi(false);
      showSwalAlert("Oops...", message, "error");
    },
  });
};

export const useUploadfilesMutation = (setLoading, dispatch) => {
  return useMutation({
    mutationFn: async (updateProfileImg) => {
      const response = await apiServices.updateProfileImg(updateProfileImg);
      return response.data;
    },
    onSuccess: (data) => {
      setLoading(false);
      dispatch({ type: "UPDATE_UPLOAD_DATA", payload: data?.data?.[0] });
    },
    onError: () => {
      setLoading(false);
    },
  });
};

const fetchUser = async ({ queryKey }) => {
  const [, userId] = queryKey;
  const response = await apiServices.getCurrentUser(userId);
  return response?.data;
};

export const useCurentUser = (userId) => {
  return useQuery({
    queryKey: ["userProfile", userId],
    queryFn: fetchUser,
    enabled: !!userId,
  });
};
